module.exports = __webpack_public_path__ + "static/media/banner-oops.992ba6a5.png";